import React, { useEffect, useState } from 'react'
import SuccessIcon from "../Images/Successtoast.png";
import ErrorIcon from "../Images/Errortoast.png";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import axios from 'axios'
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { getcoutryfromlocation, isValidPhoneNumber, validateDescription } from './utility'
import Captcha from './Captcha';
import './EnquirePopup.css';

const  apiUrl = process.env.REACT_APP_BACKEND_URL;

const EnquirePopup = (props) => {
    const [open, setOpen] = useState(props.open);
    const [userName, setUserName] = useState('');
    const [countryName, setCountryName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [businessID, setBusinessID] = useState(0);
    const [productID, setProductID] = useState(0);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [dynamicCountry, setDynamicCountry] = useState("");
    const [description, setDescription] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const [productName, setProductName] = useState("null");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState("");
    const [isError, setIsError] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isCaptchaSolved, setIsCaptchaSolved] = useState(false);
    const [invalidCaptchaErr, setInvalidCaptchaErr] = useState("");
    const [descriptionError, setDescriptionError] = useState('');
    const [countryCode, setCountryCode] = useState("in");
    const [userNameError, setUserNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [countryError, setCountryError] = useState('');

    useEffect(() => {
        setOpen(props.open);
        setBusinessID(props.businessID);
        setProductID(props.productID);
        setProductName(props.productName);
        setPhoneNumber("");
        setDescription("");
        setUserName(props.userName || "");
        setUserEmail(props.userEmail || "");
        setCountryName("")
    }, [props.open, props.businessID, props.productID, props.productName, props.userName, props.userEmail]);
    
    const handleClose = () => {
        setOpen(false);
        props.onClose();
    };
    
    const handleBlur = (value, phoneData) => {
        phoneData.iso2 = phoneData.countryCode;
        if (!!phoneNumber) {
            if (!isValidPhoneNumber(phoneNumber, phoneData)) {
                setPhoneNumberError(`Invalid phone number for ${phoneData.name}`);
            } else {
                setPhoneNumberError('');
            }
        }
    };
    
    const handledatablured = (e) => {
        const { name } = e.target;
        const value = e.target.value.trim();
    
        if (name === "userName") {
            if (!value) {
                setUserNameError("Please enter your name.");
            } else if (value.length <= 3) {
                setUserNameError("Name must be more than 3 characters.");
            } else if (!/^[A-Za-z\s]+$/.test(value)) {
                setUserNameError("Name can only contain letters and spaces.");
            } else {
                setUserNameError("");
            }
        }
    
        if (name === "userEmail") {
            if (!value) {
                setEmailError("Please enter your email.");
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                setEmailError("Please enter a valid email.");
            } else {
                setEmailError("");
            }
        }
    
        if (name === "countryName") {
            if (!value) {
                setCountryError("Please select your country.");
            } else {
                setCountryError("");
            }
        }

        if (name === "description") {
            const { valid, error } = validateDescription(value);
            if (!valid) {
              setDescriptionError(error);
            } else {
              setDescription(value);
              setDescriptionError("");
            }
          }
    };
    
    const fetchCountryfromlocation = async () => {
        try {
            const countryData = await getcoutryfromlocation();
            setCountryCode(countryData.toLowerCase());
        } catch (error) {
            console.error("Error fetching country data:", error);
        }
    };
    
    useEffect(() => {
        fetchCountryfromlocation();
    }, []);
    
    const closeModal = () => {
        setIsModalOpen(false);
        if (!isError) props.onClose();
    };
    
    const handleSubmit = () => {
      
      handledatablured({ target: { name: "userName", value: userName } });
      handledatablured({ target: { name: "userEmail", value: userEmail } });
      handledatablured({ target: { name: "countryName", value: countryName } });
      handledatablured({ target: { name: "description", value: description } });
  
      const trimmedUserName = userName.trim();
      const trimmedEmail = userEmail.trim();
  
      const nameValid = trimmedUserName && trimmedUserName.length > 3 && /^[A-Za-z\s]+$/.test(trimmedUserName);
      const emailValid = trimmedEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
      const countryValid = !!countryName;
      const phoneValid = !!phoneNumber && phoneNumberError === "";
      const descriptionValidation = validateDescription(description.trim());
      const descriptionValid = descriptionValidation.valid;
  
      if (nameValid && emailValid && countryValid && phoneValid && descriptionValid) {
          if (!!isCaptchaSolved) {
              const storedCaptcha = JSON.parse(localStorage.getItem("captcha"));
              if (!storedCaptcha) {
                  setOpen(false);
                  setResponseMessage("Captcha expired. Please try again.");
                  setIsError(true);
                  setIsModalOpen(true);
                  return;
              }
  
              setIsSubmitting(true);
              let phoneArray = phoneNumber.split("-");
              let countryCode = (phoneArray.length > 0) ? phoneArray[0] : "";
              let phone = (phoneArray.length > 0) ? phoneArray[1] : "";
  
              const requestData = {
                  enquiry_from: "influencer",
                  name: userName,
                  email: userEmail,
                  contact: phoneNumber,
                  country: countryName,
                  message: description,
                  business_id: businessID,
                  product_id: (!!productID) ? productID : 0,
                  captchaId: storedCaptcha.id,
                  captchaAns: isCaptchaSolved,
              };
  
              axios.post(`${apiUrl}api/v1/business/createBusinessEnquiry`, requestData)
                  .then(response => {
                      localStorage.removeItem("captcha");
                      setOpen(false);
                      setPhoneNumber('');
                      setDescription('');
                      setProductID(0);
                      setBusinessID(0);
                      setResponseMessage(response?.data?.message || "Enquiry submitted successfully!");
                      setIsError(false);
                      setIsModalOpen(true);
                  })
                  .catch(error => {
                      console.error("API Error:", error);
                      setProductID(0);
                      setBusinessID(0);
                      setResponseMessage(error?.response?.data?.message);
                      setIsError(true);
                      setIsModalOpen(true);
                  })
                  .finally(() => {
                      setIsSubmitting(false);
                      setTimeout(() => {
                        setIsModalOpen(false);
                        handleClose();
                    }, 3000);
                  });
  
          } else {
              setInvalidCaptchaErr("Please enter correct captcha answer.");
              setIsSubmitting(false);
          }
      } else {
          if (!phoneNumber) {
              setPhoneNumberError("Please enter phone number.");
          } else if (phoneNumberError !== '') {
              setPhoneNumberError("Please enter a valid phone number.");
          }
  
          setOpen(true);
          setIsError(true);
          setIsModalOpen(false);
      }
  };
  
    
    const handleCaptchaSolved = (solved) => {
        setIsCaptchaSolved(solved);
        setInvalidCaptchaErr("");
    };
    
    useEffect(() => {
        fetchDynamicCountry();
    }, []);
    

    const fetchDynamicCountry = async () => {
        try {
            axios
                .get(`${apiUrl}api/v1/user/getCountries`, {
                })
                .then((response) => {
                    setDynamicCountry(response?.data?.result);
                    // setIsLoading(false)

                })
                .catch((error) => {
                    console.log(error, "error in fetching");
                    // setIsLoading(false)
                });
        } catch (err) {
            // console.log(err, " eroor iiiiiiiii")
        }
    };

      

    return (
        <>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="numberpop"
        >
          <DialogTitle id="alert-dialog-title" className="text-center">
            {props.productData &&
              (props.productData[0]?.themeType === "restaurant"
                ? "Enter Order Details"
                : props.productData[0]?.themeType === "cab"
                ? "Enter Booking Details"
                : "Enter Enquiry Details") || "Enter Enquiry Details"}
          </DialogTitle>
      
          <DialogContent>
            <div>
              <input
                name="userName"
                type="text"
                className="w-full p-2 border rounded mt-2 mb-2 form-control"
                placeholder="Name"
                value={userName}
                onBlur={(e) => {
                  setUserName(e.target.value.trim());
                  handledatablured(e);
                }}
                onChange={(e) => {
                  setUserName(e.target.value);
                  if (e.target.value.trim().length > 3) setUserNameError("");
                }}
                style={{ height: "45px" }}
              />
              {!!userNameError && <p className="text-danger">{userNameError}</p>}
      
              <input
                name="userEmail"
                type="email"
                className="w-full p-2 border rounded mt-2 mb-2 form-control"
                placeholder="Email"
                value={userEmail}
                onBlur={handledatablured}
                onChange={(e) => {
                  setUserEmail(e.target.value);
                  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value)) setEmailError("");
                }}
                style={{ height: "45px" }}
              />
              {!!emailError && <p className="text-danger">{emailError}</p>}
      
              <select
                name="countryName"
                className="form-select"
                style={{ height: "45px" }}
                value={countryName}
                onBlur={handledatablured}
                onChange={(e) => {
                  setCountryName(e.target.value);
                  if (e.target.value) setCountryError("");
                }}
              >
                <option value="">Select Country</option>
                {!!dynamicCountry?.length &&
                  dynamicCountry.map((country) => (
                    !!country?.id && (
                      <option key={country.name} value={country.short_code}>
                        {country.name.charAt(0).toUpperCase() + country.name.slice(1)}
                      </option>
                    )
                  ))}
              </select>
              {!!countryError && <p className="text-danger">{countryError}</p>}
      
              <PhoneInput
                country={countryCode}
                enableSearch
                value={phoneNumber}
                countryCodeEditable={false}
                onChange={(value, country) => {
                  if (country.dialCode) {
                    setPhoneNumber(`+${country.dialCode}-${value.substring(country.dialCode.length)}`);
                    setPhoneNumberError("");
                  } else {
                    setPhoneNumber(value);
                    setPhoneNumberError("");
                  }
                }}
                className="customer-info-phone"
                onBlur={(e, country) => handleBlur(e, country)}
                isValid={(inputNumber, country) => isValidPhoneNumber(inputNumber, country)}
                style={{ height: "45px" }}
              />
              {!!phoneNumberError && <p className="text-danger">{phoneNumberError}</p>}
      
              <div className="mt-4">
                <textarea
                   id="description"
                    name="description"
                  className="w-full p-2 border rounded mt-2 mb-2 form-control"
                  placeholder={
                    props.productData &&
                    (props.productData[0]?.themeType === "restaurant"
                      ? "Enter your Order Details (optional)"
                      : props.productData[0]?.themeType === "cab"
                      ? "Enter your Booking Details (optional)"
                      : "Enter your Enquiry Details (optional)") || "Enter your Enquiry Details (optional)"
                  }
                  rows="3"
                  value={description}
                  onChange={(e) => {
                    const value = e.target.value;
                    const { valid, error } = validateDescription(value);
                    if (valid) setDescription(value);
                    setDescriptionError(error);
                  }}
                  onBlur={handledatablured}
                />
              </div>
              {!!descriptionError && <p className="text-danger">{descriptionError}</p>}
      
              <div className="captcha-container">
                <Captcha onCaptchaSolved={handleCaptchaSolved} />
              </div>
              {!!invalidCaptchaErr && <p className="text-danger">{invalidCaptchaErr}</p>}
            </div>
      
            <div className="enquirybtndiv">
              <button onClick={handleSubmit}>
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </DialogContent>
        </Dialog>
      
        {isModalOpen && (
          <div className="modal1">
            <div className="modal-content1">
              <span className="close closeIconstyle" onClick={closeModal}>X</span>
              <div>
                {isError ? (
                  <img className="toastsuccessimg" src={ErrorIcon} alt="erricon" />
                ) : (
                  <img className="toastsuccessimg" src={SuccessIcon} alt="successicon" />
                )}
              </div>
              <div className="headtostmsg">{isError ? "Error !" : "Enquiry Received !"}</div>
              <p className="responseMessagestyle">{responseMessage}</p>
            </div>
          </div>
        )}
      </>
    )
}

export default EnquirePopup